/**
 * Dulux Duratec powder-coat colour palette used across steel doors & windows.
 * Each entry:
 *  - key: unique slug (used for filter ids + testids)
 *  - label: what shows in UI / gets sent to the backend Colour enum
 *  - hex: swatch fill
 *  - target: rgb tuple (0..1) used by the SVG feColorMatrix to remap black -> colour
 *  - filter: SVG filter id to reference (null = no visual change)
 */
export const COLOURS = [
  {
    key: "black",
    label: "Black",
    hex: "#0f0f0f",
    filter: null, // frame is already black — no tint needed
  },
  {
    key: "white",
    label: "White",
    hex: "#e8e5dc",
    filter: "tint-white",
    target: [232 / 255, 229 / 255, 220 / 255],
  },
  {
    key: "flaxpod",
    label: "Flaxpod",
    hex: "#3a3628",
    filter: "tint-flaxpod",
    target: [58 / 255, 54 / 255, 40 / 255],
  },
  {
    key: "desert-sand",
    label: "Desert Sand",
    hex: "#d4c2a3",
    filter: "tint-desert-sand",
    target: [212 / 255, 194 / 255, 163 / 255],
  },
  {
    key: "electro-dark-bronze",
    label: "Electro Dark Bronze",
    hex: "#3a2b20",
    filter: "tint-electro-dark-bronze",
    target: [58 / 255, 43 / 255, 32 / 255],
  },
  {
    key: "custom",
    label: "Custom",
    hex: null, // rendered as a special swatch (diagonal hatch), no visual change
    filter: null,
  },
];

export const DEFAULT_COLOUR_KEY = "black";

export function getColour(key) {
  return COLOURS.find((c) => c.key === key) || COLOURS[0];
}
